import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { isArray } from 'lodash-es';
import service from '@/service';
import { RootState } from './rootReducer';
import { AppThunk } from '.';

export type Role = {
  platformRole: string;
  projectRole: Array<string>;
};

type InitialState = {
  // 可修改的角色范围
  platformRoleList: Array<{ label: string; value: string }>;
  projectRoleList: Array<{ label: string; value: string }>;
};

const initialState: InitialState = {
  platformRoleList: [],
  projectRoleList: [],
};

const userSettings = createSlice({
  name: 'settings',
  initialState,
  reducers: {
    setSettingOptions(
      state,
      { payload }: PayloadAction<Array<{ roleType: string; roleName: string; roleCode: string }>>,
    ) {
      let platformRoleList: Array<{ label: string; value: string }> = [];
      let projectRoleList: Array<{ label: string; value: string }> = [];

      if (payload && isArray(payload)) {
        payload?.forEach(({ roleType, roleName, roleCode }) => {
          if (roleType === 'PLATFORM') {
            platformRoleList.push({ label: roleName, value: roleCode });
          }
          if (roleType === 'PROJECT') {
            projectRoleList.push({ label: roleName, value: roleCode });
          }
        });
        state.platformRoleList = platformRoleList;
        state.projectRoleList = projectRoleList;
      }
    },
  },
});

export const { setSettingOptions } = userSettings.actions;

export const selectUserSettings = (state: RootState) => state.userSettings;

export const initSettingOptions =
  (projectCode): AppThunk =>
  async (dispatch, getState) => {
    if (!projectCode) {
      return;
    }
    // 可配置列表
    const userRoleList = await service.userSetting.getProjectRoleOptions(projectCode);
    dispatch(setSettingOptions(userRoleList));
  };

export default userSettings.reducer;
